var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsSafePaymentIcon = function SvgDsSafePaymentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.084 6.427a.667.667 0 0 0-1.025-.854L7.67 8.441 6.471 7.243a.667.667 0 1 0-.942.943L7.243 9.9a.667.667 0 0 0 .983-.045z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.667 2.75 8 .634 1.333 2.75v6.202c0 3.555 3.016 6.381 6.667 6.381s6.667-2.826 6.667-6.38zm-12 6.202V3.726L8 2.033l5.333 1.693v5.226C13.333 11.71 10.977 14 8 14s-5.333-2.29-5.333-5.048",
    clipRule: "evenodd"
  })));
};
export default SvgDsSafePaymentIcon;